import * as React from 'react';
import { Link, Stack, SvgIconProps } from '@mui/material';

import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { TiktokIcon } from '../icons/tiktok-logo';
import { styled } from '@mui/material/styles';

export const SocialMediaMarks = ({ fontSize }: { fontSize?: number }) => {
  const iconProps = { sx: { fontSize: fontSize ?? 35 } };
  return (
    <Stack direction="row" spacing={1}>
      <FacebookLink {...iconProps} />
      <InstagramLink {...iconProps} />
      <LinkedInLink {...iconProps} />
      <YoutubeLink {...iconProps} />
      <TiktokLink {...iconProps} />
    </Stack>
  );
};

const NeutralLink = styled(Link)(({ theme }) => ({
  color: theme.palette.neutral.main,
  '&:hover': {
    color: theme.palette.secondary.dark
  }
}));

export const FacebookLink: React.FunctionComponent<SvgIconProps> = (props) => {
  const facebookAccountLink = 'https://www.facebook.com/ClassicVacations';
  return (
    <NeutralLink href={facebookAccountLink} rel="noopener noreferrer" target="_blank">
      <FacebookIcon {...props} />
    </NeutralLink>
  );
};

export const InstagramLink: React.FunctionComponent<SvgIconProps> = (props) => {
  const InstagramAccountLink = 'https://www.instagram.com/weareclassicvacations/';
  return (
    <NeutralLink href={InstagramAccountLink} rel="noopener noreferrer" target="_blank">
      <InstagramIcon {...props} />
    </NeutralLink>
  );
};

export const LinkedInLink: React.FunctionComponent<SvgIconProps> = (props) => {
  const LinkedInAccountLink = 'https://www.linkedin.com/company/classic-vacations/';
  return (
    <NeutralLink href={LinkedInAccountLink} rel="noopener noreferrer" target="_blank">
      <LinkedInIcon {...props} />
    </NeutralLink>
  );
};

export const YoutubeLink: React.FunctionComponent<SvgIconProps> = (props) => {
  const YoutubeAccountLink = 'https://www.youtube.com/@Classicvacations';
  return (
    <NeutralLink href={YoutubeAccountLink} rel="noopener noreferrer" target="_blank">
      <YouTubeIcon {...props} />
    </NeutralLink>
  );
};

export const TiktokLink: React.FunctionComponent<SvgIconProps> = (props) => {
  const TiktokAccountLink = 'https://www.tiktok.com/@weareclassicvacations';
  return (
    <NeutralLink href={TiktokAccountLink} rel="noopener noreferrer" target="_blank">
      <TiktokIcon {...props} />
    </NeutralLink>
  );
};
